module.exports = __webpack_public_path__ + "img/aston-online-course.565546f2.webp";